import { useContactChannelsContext as f } from "./contact-channels19.js";
import { useRecaptchaContext as A } from "./contact-channels69.js";
import { NRLogger as r } from "./contact-channels45.js";
import { attempt as c } from "./contact-channels54.js";
import { useMutation as d } from "./contact-channels92.js";
const S = () => {
  const { locale: e, tenant: u, origin: t, auth: n } = f(), { getRecaptchaToken: l } = A();
  return d({ mutationKey: ["emailActions"], mutationFn: async (i) => {
    const { data: m, error: C } = await c(l()), a = i.caseType;
    if (C)
      return r.error("Contact Channels: Recaptcha", {
        ...C,
        locale: e,
        action: "CreateEmailCase",
        caseType: a,
        origin: t
      }), {
        success: !1,
        error: "RECAPTCHA_ERROR"
      };
    const { data: o, error: p } = await c(
      fetch(`https://help-case-creation-service.care.vpsvc.com/v1/case/origins/${a}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/plain, */*",
          Authorization: (n == null ? void 0 : n.getAuthorizationHeader()) || "",
          "x-recap-token": m || "",
          "x-requestor": t || "unset"
        },
        body: JSON.stringify({
          locale: e,
          tenant: u,
          origin: t,
          ...i
        })
      })
    );
    if (p)
      return r.error("Contact Channels: Email Actions", {
        ...p,
        type: "REQUEST_ERROR",
        caseType: a,
        action: "CreateEmailCase",
        locale: e,
        origin: t
      }), {
        success: !1,
        error: "INTERNAL_ERROR"
      };
    if (!o.ok) {
      const E = await o.text(), { data: s } = c(() => JSON.parse(E)), h = (s == null ? void 0 : s.code) || "INTERNAL_ERROR";
      return r.error("Contact Channels: Email Actions", {
        status: o.status,
        ...s,
        type: "BAD_RESPONSE",
        caseType: a,
        action: "CreateEmailCase",
        locale: e,
        origin: t
      }), {
        success: !1,
        error: h
      };
    }
    const R = await o.json();
    return r.info("Contact Channels: Email Actions", {
      status: o.status,
      caseType: a,
      action: "CreateEmailCase",
      locale: e,
      origin: t
    }), {
      success: !0,
      data: R
    };
  } });
};
export {
  S as useCreateCase
};
//# sourceMappingURL=contact-channels60.js.map
